import styles from './ProfilePage.module.css'
import ProfileHeader from "./ProfileHeader/ProfileHeader.tsx";
import BalanceTop from "../../components/BalanceTop/BalanceTop.tsx";
import ProfileMenu from "./ProfileMenu/ProfileMenu.tsx";
import HaveInventory from "./HaveInventory/HaveInventory.tsx";
import {useEffect, useState} from "react";
import {getProfile} from "../../Requests/profile/profile.ts";
import NoInventory from "./NoInventory/NoInventory.tsx";
import type { WebApp } from '../../types/telegram';
import Loader from "../../components/Loader/Loader.tsx";

interface ExtendedWebApp extends WebApp {
    contentSafeAreaInset?: {
        top: number;
        bottom: number;
        left: number;
        right: number;
    };
}

interface IProfile {
    user: {
        id: number,
        username: string,
        name: string,
        photo_url: string
    },
    inventory: {
        items:
            {
                currency: string,
                amount: number,
                name: string,
                price: number,
                image: string
            }[]

    }
}

const ProfilePage = () => {

    const [profileData, setProfileData] = useState<IProfile>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [displayedItems, setDisplayedItems] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState<boolean>(true);

    const itemsPerPage = 20;

    useEffect(() => {
        const tg = window.Telegram?.WebApp as ExtendedWebApp;
        if (!tg) return;

        const apply = () => {
            const top = tg?.contentSafeAreaInset?.top ?? 0;
            document.documentElement.style.setProperty(
                '--tg-viewport-content-safe-area-inset-top',
                `${top}px`,
            );
        };

        apply();
        tg.onEvent?.('contentSafeAreaChanged', apply);
        return () => tg.offEvent?.('contentSafeAreaChanged', apply);
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const tg = window.Telegram?.WebApp.initData
            if (tg) {
                const data = await getProfile(tg);
                setProfileData(data)
                if (data && data.inventory.items) {
                    setDisplayedItems(data.inventory.items.slice(0, itemsPerPage));
                    setHasMore(data.inventory.items.length > itemsPerPage);
                }
                setIsLoading(false);
            }
        })()
    },[])

    const loadMoreItems = () => {
        if (profileData) {
            const nextPage = page + 1;
            const newItems = profileData.inventory.items.slice(0, nextPage * itemsPerPage);
            setDisplayedItems(newItems);
            setPage(nextPage);
            setHasMore(newItems.length < profileData.inventory.items.length);
        }
    };

  return (
      <div className={styles.container}>
          {isLoading ? (
              <Loader/>
          ) : (
              <div className={styles.contentContainer}>
                  <ProfileHeader/>
                  <BalanceTop/>
                  <ProfileMenu/>
                  {profileData?.inventory.items && profileData.inventory.items.length > 0 ? (
                      <HaveInventory inventory={{items: displayedItems}} loadMore={loadMoreItems} hasMore={hasMore}/>
                  ) : (
                      <NoInventory />
                  )}
              </div>
          )}
      </div>
  )
};

export default ProfilePage;
